import { render, staticRenderFns } from "./client-dialog-location-tab.vue?vue&type=template&id=17cf0c55"
import script from "./client-dialog-location-tab.vue?vue&type=script&lang=js"
export * from "./client-dialog-location-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports